import type { FunctionComponent } from "react";
import { SignInButton, SignUpButton } from "@clerk/react";
import { CheckCircle2 } from "lucide-react";
import { authStyles } from "./authStyles";

interface Props {
  readonly message?: string;
}

const FEATURES = [
  "5 AI coaching reports / month",
  "Save games to your library",
  "Personal stats dashboard",
  "Spaced repetition drills",
];

export const SignInPrompt: FunctionComponent<Props> = ({ message }) => (
  <div style={authStyles.promptOverlay}>
    <div style={authStyles.promptCard}>
      <div style={authStyles.promptIcon}>
        <svg
          width="48"
          height="48"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#58a6ff"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
        >
          <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
          <path d="M7 11V7a5 5 0 0 1 10 0v4" />
        </svg>
      </div>
      <h2 style={authStyles.promptTitle}>Create a free account</h2>
      <p style={authStyles.promptSubtitle}>No credit card needed</p>
      <p style={authStyles.promptMessage}>{message || ""}</p>
      <div style={authStyles.promptFeatures}>
        {FEATURES.map((feature) => (
          <div key={feature} style={authStyles.promptFeature}>
            <CheckCircle2
              size={18}
              className="text-[var(--color-success)] shrink-0"
              aria-hidden="true"
            />
            {feature}
          </div>
        ))}
      </div>
      <div style={authStyles.promptButtons}>
        <SignUpButton mode="modal">
          <button style={authStyles.promptSignIn}>Sign Up</button>
        </SignUpButton>
        <SignInButton mode="modal">
          <button style={authStyles.promptSignUp}>Sign In</button>
        </SignInButton>
      </div>
      <p style={authStyles.promptFooter}>
        Stockfish analysis runs free in your browser — no account needed.
      </p>
    </div>
  </div>
);
